/*
 * Functions for history tables used by various CB objects.
 */

(function (c2, $) {
  'use strict';


  /*
   * Load JSON data and assign it to the history DataTable.
   *
   * The history table is implemented differently from most others that have a
   * remote data source. Instead of letting DataTables own the process by just
   * giving it a source URL, we fetch JSON data directly so it can be used by
   * other components on the page.
   *
   * Therefore, to reload the history table, we can't reload these the standard
   * way, by calling $('#history').DataTable().ajax.reload(). Instead, call
   * this function to reload the table.
   */
  function loadHistoryData(url) {
    var $table = $('#history');
    var $wrapper = $('#tab-history');

    // Present a not-cut-off spinner
    $wrapper.css('min-height', '200px');
    c2.spinners.showSpinner({selector: '#history', fade: true})

    if (url) {
      // Save the URL on the table, so other callers (e.g. server details live updates) don't have to know it too.
      $table.data('table-source-data-url', url);
    } else {
      url = $table.data('table-source-data-url');
    }

    /*
    Due to the expense of getting a potentially large history, this table's rows
    are also used by the stats tab's charts.  Because of that, the data is
    fetched only once, asynchronously, and attached to dataTable as local JSON
    data. This way the table is also able to handle paging, sorting, and search
    client-side instead of going back to the server.
    */
    $.get(url, function(response) {
      var allServerEvents = [];
      if (response.aaData) {
        allServerEvents = response.aaData;

        if ($.fn.dataTable.isDataTable($table.get(0))) {
          // Already initialized (e.g. this is a Refresh click, not the first
          // load) -- c2.dataTables.init() no-ops on a table that's already a
          // DataTable, so the fetched rows have to be applied via the
          // DataTables API instead.
          $table.DataTable().clear().rows.add(allServerEvents).draw();
        } else {
          // Assign JSON object to the data-table-source attribute
          $table.data('table-source', allServerEvents);
          c2.dataTables.init('#history');
        }
      } else {
        $table.insertAfter('<div class="alert alert-danger">Failed to retrieve history data</div>');
      }

      // Now that the table has data, draw the server stats charts, if any. Called here
      // because they depend on history event data to exist in the page first.
      c2.serverStats.drawCharts(allServerEvents);

      c2.spinners.hideSpinner({selector: '#history', fade: true})
    });
  }


  c2.history = {
    loadHistoryData: loadHistoryData
  };
})(window.c2, window.jQuery);
